import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["select"];
  static values = { options: Array, selecteds: Array, maxItems: String };

  connect() {
    new TomSelect(this.selectTarget, {
      valueField: "id",
      labelField: ["name"],
      searchField: ["name"],
      maxItems: this.selectTarget.multiple ? null : this.maxItemsValue || 1,
      plugins: this.selectTarget.multiple ? ["remove_button"] : [],
      options: this.optionsValue,
      items: this.selectedsValue,
    });
  }
}
